// extracted by mini-css-extract-plugin
module.exports = {"default":"ServerLinkSecondary_default__FyRBp","inverse":"ServerLinkSecondary_inverse__NGCpR"};